import React, { Component } from 'react';
import { Flex, Text, Icon } from 'core/components';
import ToolResultCard from '../components/ToolResultCard';

class SitesToolResult extends Component {
  render() {
    const { tool, onCloseToolResult, isInlineMode } = this.props;
    const results = tool?.raw_result?.results || [];

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        isInlineMode={isInlineMode}
        className="tool-result-sites"
        title={tool.title || 'Sites Tool Result'}
      >
        <Flex flexDirection="column" px={2} pb={2} gap={1}>
          {results.length === 0 && <Text muted>No site results.</Text>}
          {results.map((siteResult) => (
            <Flex key={siteResult.name} alignItems="center" gap={1}>
              <Icon
                icon={siteResult.error ? 'error' : 'tick-circle'}
                color={siteResult.error ? 'danger' : 'success'}
                size={14}
              />
              <Flex flexDirection="column">
                <Text fontWeight={500}>{siteResult.name}</Text>
                {siteResult.error ? (
                  <Text small color="danger">
                    {siteResult.error}
                  </Text>
                ) : (
                  <Text small color="muted">
                    {siteResult.action}
                    {siteResult.id ? ` (id: ${siteResult.id})` : ''}
                  </Text>
                )}
              </Flex>
            </Flex>
          ))}
        </Flex>
      </ToolResultCard>
    );
  }
}
export default SitesToolResult;
